
const env = process.env.REACT_APP_CUSTOM_ENV.trim()
console.log('env:', env)

const appName = env === "development" ? "Analytics as a Service (A3S) Historical Dev" : env === "test" ? "Analytics as a Service (A3S) Historical  QA" : "Analytics as a Service (A3S) Historical"
const provisioningInfo = {
    roles: [
        {
            name: appName,
            description: 'Generated role for A3S',
            permissionPolicies: [
                { // permission to allow backend to retrieve all integration types in validate org
                    domain: 'integration',
                    entityName: 'A3S',
                    actionSet: ["view"],
                    allowConditions: false
                },
                { // permission to allow backend to retrieve all integration types in validate org
                    domain: 'integrations',
                    entityName: 'integration',
                    actionSet: ["view"],
                    allowConditions: false
                },
                {
                    "domain": "authorization",
                    "entityName": "role",
                    "actionSet": ["*"],
                    "allowConditions": false
                },
                {
                    "domain": "routing",
                    "entityName": "queue",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "analytics",
                    "entityName": "conversationDetail",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "analytics",
                    "entityName": "userDetail",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "architect",
                    "entityName": "datatable",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "routing",
                    "entityName": "wrapupCode",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "speechAndTextAnalytics",
                    "entityName": "program",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "speechAndTextAnalytics",
                    "entityName": "topic",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "recording",
                    "entityName": "recording",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "quality",
                    "entityName": "evaluationForm",
                    "actionSet": ["view"],
                    "allowConditions": false
                },
                {
                    "domain": "audits",
                    "entityName": "audit",
                    "actionSet": ["view"],
                    "allowConditions": false
                }]
        }
    ],
    oauth: {
        name: appName + ' OAuth',
        description: `Generated OAuth Client that is used by the application backend`,
        authorizedGrantType: 'CLIENT_CREDENTIALS'
    }
};

const development = {
    //clientId: 'dc7cc51b-ed8f-4eb9-8a14-36a90468c1f4',
    clientId: 'd4dfa94d-d68a-417f-800c-baf332b178c1',
    endpoints: {
        backend: 'https://d3hozt8th7.execute-api.us-east-1.amazonaws.com/dev'
    },
    appName: appName,
    appUrl: "http://localhost:3000/",
    //appUrl: "https://d35sj8i8ddgep1.cloudfront.net/",
    integrationType: "premium-app-example",
    permissionPolicyEntityName: "examplePremiumApp",
    defaultPcEnv: "mypurecloud.com",
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo
}

const qa = {
    clientId: 'dc7cc51b-ed8f-4eb9-8a14-36a90468c1f4',
    endpoints: {
        backend: 'https://j5wx6ow2ta.execute-api.us-east-1.amazonaws.com/test',
    },
    appName: appName,
    appUrl: "https://d3ux05dpm61vce.cloudfront.net/",
    integrationType: "premium-app-a3s",
    permissionPolicyEntityName: "A3S",
    defaultPcEnv: "mypurecloud.com",
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo
}

const production = {
    clientId: 'dc7cc51b-ed8f-4eb9-8a14-36a90468c1f4',
    endpoints: {
        backend: 'https://v0g24j8jn2.execute-api.us-east-1.amazonaws.com/prod',
    },
    appName: appName,
    appUrl: "https://a3spremium.genesyspsapps.com/",
    integrationType: "premium-app-a3s",
    permissionPolicyEntityName: "A3S",
    defaultPcEnv: "mypurecloud.com",
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo
}

let config
switch (env) {
    case 'production': config = production; break;
    case 'development': config = development; break;
    case 'test': config = qa; break;
    default: break;
}

export default config
export const headerTitle = "Analytics as a Service (A3S) Historical"